export type PageLoadStartedInfo = {
  name         ?: string,
  geoRegion    ?: string,
  [key: string] : unknown
};